export { Fredcon24 } from './Fredcon24';
